import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, MonoTypeOperatorFunction, catchError } from 'rxjs';

export type UserFacingError = HttpErrorResponse & { userMessage: string; };

export function handleHttpError<T>(): MonoTypeOperatorFunction<T> {
  return catchError((err: HttpErrorResponse): Observable<never> => {
    console.error(err);
    return throwError(() => mapHttpError(err));
  });
}

function mapHttpError(err: HttpErrorResponse): UserFacingError {
  const userMessage =
    err.status === 401 ? 'Access denied' :
    err.status === 404 ? 'Resource not found' :
    'An unexpected error occurred';
  return { ...err, userMessage } as UserFacingError;
}


